/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventformstillopen3Inputs */

const en_eventformstillopen3 = /** @type {(inputs: Eventformstillopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still to do:`)
};

const de_eventformstillopen3 = /** @type {(inputs: Eventformstillopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch offen:`)
};

/**
* | output |
* | --- |
* | "Still to do:" |
*
* @param {Eventformstillopen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventformstillopen3 = /** @type {((inputs?: Eventformstillopen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventformstillopen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventformstillopen3(inputs)
	return de_eventformstillopen3(inputs)
});
export { eventformstillopen3 as "eventFormStillOpen" }